import http from 'core/services/http';
import Config from 'core/config';

class TaskManagementService {
  static getTasks(cycleId) {
    return http.get(`${Config.apiUrl}/task?category=room&cycleId=${cycleId}`);
  }

  static getRoomCompletedTasks(roomId) {
    return http.get(`${Config.apiUrl}/room/${roomId}/roomtask`);
  }

  static getRoomStatus(roomId) {
    return http.get(`${Config.apiUrl}/room/${roomId}/status`);
  }

  static setCompleteTask(roomId, taskId) {
    return http.post(`${Config.apiUrl}/room/${roomId}/completeTask`, { taskId });
  }

  static pauseTimer(roomId) {
    return http.post(`${Config.apiUrl}/room/${roomId}/pause`);
  }

  static resumeTimer(roomId, irregularity) {
    return http.post(`${Config.apiUrl}/room/${roomId}/irregularity/unpause`, irregularity);
    //deprecated
    // return http.post(`${Config.apiUrl}/room/${roomId}/unpause`, { irregularityId });
  }

  static getRoomTimers(roomId) {
    return http.get(`${Config.apiUrl}/room/${roomId}/roomtimer`);
  }

  static setRoomTimer(roomId, data) {
    return http.post(`${Config.apiUrl}/room/${roomId}/roomtimer`, data);
  }

  static completeWarningTask(roomId, data) {
    return http.post(`${Config.apiUrl}/room/${roomId}/roomtask`, data);
  }

  static getRegsAssessments(regId, tcEvId) {
    return http.get(`${Config.apiUrl}/registration/${regId}/assessment?testcentereventid=${tcEvId}`);
  }

  static updateRegAssessment(regId, data) {
    return http.put(`${Config.apiUrl}/registration/${regId}/assessment`, data);
  }

  static getRoomSummary(roomId) {
    return http.get(`${Config.apiUrl}/room/${roomId}/summary`);
  }

  static getRoomMaterialSummary(roomId) {
    return http.get(`${Config.apiUrl}/query/roomMaterialSummary?roomId=${roomId}`);
  }

  static getTiming(roomId) {
    return http.get(`${Config.apiUrl}/query/roomTimers?roomId=${roomId}`);
  }

  static getRoomTestedStatusSummary(roomId) {
    return http.get(`${Config.apiUrl}/query/roomTestedStatusSummary?roomId=${roomId}`);
  }

  static getRoomTestedStatusReg(roomId, testedStatus) {
    return http.get(`${Config.apiUrl}/query/roomTestedStatusReg?roomId=${roomId}&testedStatus=${testedStatus}`);
  }

  static getRoomIrregularities(roomId) {
    return http.get(`${Config.apiUrl}/room/${roomId}/irregularityExaminees`);
  }
}

export default TaskManagementService;
